import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { LoginMethod } from '../Login';
import Or from './Or';
import styles from './ChangeMethodSignUp.module.scss';

export default function ChangeMethodSignUp({
  className = '',
  method,
  clearEmailSent
}: {
  className?: string;
  method: LoginMethod;
  clearEmailSent?: () => void;
}) {
  const router = useRouter();
  const currentQuery = { ...router.query };

  // Update only the method parameter
  const newQuery = {
    ...currentQuery,
    method: method === LoginMethod.Password ? LoginMethod.MagicLink : LoginMethod.Password
  };

  // Construct the new URL with all query parameters
  const queryString = Object.entries(newQuery)
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
    .join('&');

  return (
    <div
      className={`${styles.ChangeMethodSignUp} ${className}`}
    >
      <Or
        className={styles.OrLayout}
      />
      <Link
        href={`/login?${queryString}`}
        passHref
      >
        {/* eslint-disable */}
        <a
          className={styles.Forgot}
          onClick={clearEmailSent}
        >
          {method === LoginMethod.Password ? 'Sign in with just your email' : 'Sign in with a password'}
        </a>
      </Link>
      <p className={styles.SignUp}>Don&apos;t have an account? <Link href="/users/add">Sign up.</Link></p>
    </div>
  );
}
